import { useSelector } from 'react-redux';
import { activeContactSelector } from '../../ccf-inbox/ccf-inbox.slice';
import CcfLiveCopilot from './ccf-live-copilot';
import CcfScriptedCopilot from './ccf-scripted-copilot/ccf-scripted-copilot';

/* eslint-disable-next-line */
export interface CcfCopilotProps {}

/**
 * CcfCopilot - used to display Copilot tab in App Space
 * @param props -?-CcfCopilotProps
 * @example <CcfCopilot />
 */
export function CcfCopilot(props: CcfCopilotProps) {
  const activeContact = useSelector(activeContactSelector);

  return activeContact?.copilotSource === 'JSON' ? (
    <CcfScriptedCopilot />
  ) : (
    <CcfLiveCopilot />
  );
}

export default CcfCopilot;